import React, { Component } from 'react'
class IconType extends Component {
  render () {
    switch(true) {
      case this.props.provider == 'ads-post':
        return (<i {...this.props} className="fas fa-ad" />)
        break
      case this.props.type == 'IMAGE':
      case this.props.type == 'PHOTO':
      case this.props.type == 'PICTURE':
        return (<i {...this.props} className="fas fa-image" />)
        break
      case this.props.type == 'ALBUM':
        return (<i {...this.props} className="fas fa-images" />)
        break
      case this.props.type == 'VIDEO':
        return (<i {...this.props} className="fas fa-video" />)
        break
      case this.props.type == 'CAROUSEL_ALBUM':
        return (<i {...this.props} className="fas fa-th" />)
        break
      case this.props.type == 'MUSIC':
        return (<i {...this.props} className="fas fa-music" />)
        break
      case this.props.type == 'STATUS':
      case this.props.type == 'RICH':
      case this.props.type == 'TEXT':
        return (<i {...this.props} className="fas fa-font" />)
        break
      case this.props.type == 'LINK':
        return (<i {...this.props} className="fas fa-link" />)
        break
      case this.props.type == 'OFFER':
        return (<i {...this.props} className="fas fa-tag" />)
        break
      case this.props.type == 'ARTICLE':
        return (<i {...this.props} className="far fa-newspaper" />)
        break
      case this.props.type == 'EVENT':
        return (<i {...this.props} className="fas fa-calendar-alt"/>)
        break
      case this.props.type == 'NOTE':
        return (<i {...this.props} className="fas fa-sticky-note"/>)
        break
      case this.props.type == 'STORY_VIDEO':
      case this.props.type == 'STORY_IMAGE':
        return (<i {...this.props} className="far fa-hourglass" />)
        break
      default:
        return (<i {...this.props} />)
        break
    }
  }
}

export default IconType


// WEBPACK FOOTER //
// ./src/components/Shared/IconType/index.js